module.exports = __webpack_public_path__ + "static/media/dissectProcess1.e314bd4a.jpeg";